import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { EventComplete } from "../../models/events/event-complete.model";
import { empty } from "rxjs";
import { EventHostComplete } from "../../models/event-hosts/event-host-complete.model";
import { EventSystemComplete } from "../../models/event-systems/event-system-complete.model";
import { UserBasic } from "../../models/account/user-basic.model";
import { EventBasic } from "../../models/events/event-basic.model";
import { UserComplete } from "../../models/account/user-complete.model";
import { EventTicketComplete } from "../../models/event-tickets/event-ticket-complete.model";
import { EventCreation } from "../../models/events/event-creation.model";
import { Update } from "@ngrx/entity";
import { Organiser } from "../../models/organisers/organiser.model";
import { EventBookingComplete } from "../../models/event-bookings/event-booking-complete.model";

export const adminActions = createActionGroup({
    source: 'Admin',
    events: {
        'Get all events': emptyProps,
        'Get archived events': emptyProps,
        'Get event': props<{ eventRef: string }>(),
        'Get event hosts': emptyProps,
        'Get event systems': emptyProps,
        'Get users': emptyProps,
        'Get single privileged user': props<{ userId: number }>(),
        'Get single user': props<{ userId: number }>(),
        'Update event ticket': props<{ eventTicket: EventTicketComplete }>(),
        'Add event ticket': props<{ eventTicket: EventTicketComplete }>(),
        'Change Menu Visiblity': props<{ visibility: boolean}>(),
        'Create new event': props<{ lrpEvent: EventCreation }>(),
        'Update Event': props<{  update: Update<EventComplete> }>(),
        'Get ticket types': emptyProps,
        'Get Organisers': emptyProps,
        'Get event booking': props<{ eventRef: string, bookingId: number}>()
    }
})

export const adminApiActions = createActionGroup({
    source: 'Admin API',
    events: {
        'Fetch all events': props<{ events: EventComplete[] }>(),
        'Fetch archived events': props<{ events: EventComplete[] }>(),
        'Fetch event': props<{ event: EventComplete }>(),
        'Fetch event hosts': props<{ eventHosts: EventHostComplete[] }>(),
        'Fetch event systems': props<{ eventSystems: EventSystemComplete[] }>(),
        'Fetch users': props<{ user: [UserBasic[], UserBasic[]] }>(),
        'Fetch single privileged user': props<{ user: UserComplete}>(),
        'Fetch single user': props<{ user: UserComplete}>(),
        'Updated event ticket': props<{ update: Update<EventComplete> }>(),
        'Created event ticket': props<{ update: Update<EventComplete> }>(),
        'Event created': props<{ lrpEvent: EventComplete}>(),
        'Event updated': props<{ lrpEvent: EventComplete}>(),
        'Fetch ticket types': props<{ ticketTypes: string[]}>(),
        'Fetch organisers': props<{ organisers: Organiser[]}>(),
        'Update organiser': props<{ update: Update<Organiser>}>(),
        'Fetch event booking': props<{ update: Update<EventComplete> }>()
    }
})